<template>
  <div id="main">
    <!-- <Nav v-if="!$route.meta.login" /> -->
    <router-view />
  </div>
</template>

<script>
import logAndSign from './request/APIs/logAndSign'
export default {
  components: {
    // Nav
  },

  data () {
    return {
      user: {}
    }
  },

  created () {
    // 判断登录状态
    logAndSign.getUserInfo().then((res) => {
      // 已经登陆直接跳转
      if (res.code === 1) { window.location.href = '/main.html' }
    })
  }
}
</script>

<style lang="less">
@import '~@/styles/main.css';
@import '~@/styles/main.less';
@import '~@/styles/setting.less';
@import '~@/styles/flex.less';
@import '~@/styles/transition.less';
#app {
  font-family: Arial,Avenir, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#main{
  width: 100%;
  height:100%;
}
</style>
